import {
  publishEvent,
  ParticipantResult,
} from '@salesforce/scv-connector-base';
import type { Call } from '@entities/call';
import { CallInfoGenerator } from '@main/generators/call-info.generator';
import { Logger } from '@main/utils/logger';
import type { ConnectedTransferCallEventPublisher } from './connect-merge-transfer-call.usecase';

export class ConnectedTransferCallPublisher
  implements ConnectedTransferCallEventPublisher
{
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  async publish(
    call: Call,
    isRecordingPaused = true,
    recordEnabled = false,
  ): Promise<void> {
    const callInfo = CallInfoGenerator.generateWithRecordingCapabilities(
      call.id,
      isRecordingPaused,
      recordEnabled,
    );

    this.logger.info('Publisher: Connect participant', {
      action: 'ConnectParticipant',
      ...call,
    });

    const participantResult = new ParticipantResult({
      initialCallHasEnded: false,
      callInfo: callInfo,
      phoneNumber: call.name || call.to,
      callId: call.id,
    });

    publishEvent({
      eventType: 'PARTICIPANT_CONNECTED',
      payload: participantResult,
      registerLog: false,
    });
  }
}
